module.exports = __webpack_public_path__ + "img/modi-logo.9dca020b.png";